import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, DoCheck, IterableDiffer, IterableDiffers, Renderer2,  ViewChild, ElementRef, HostListener} from '@angular/core';
import { LinkService } from 'src/app/reports/shared/link/services/link.service';
import { RelatedEntity } from 'src/app/reports/components/report/models/related-entity.model';
import { ReportEntity } from 'src/app/reports/components/report/models/report-entity.model';
import { AfterRegisterLink } from 'src/app/reports/shared/link/models/after-register-link.model';
import { Column } from 'src/app/reports/components/report/models/column.model';
import { QueryService } from 'src/app/reports/services/query.service';
import { DialogConfirmHelper } from 'src/app/reports/helpers/dialogconfirm.helper';
import { BeforeRegisterLink } from 'src/app/reports/shared/link/models/before-register-link.model';
import { LinkElement } from 'src/app/reports/shared/link/models/link-element.model';
import { Link } from 'src/app/reports/shared/link/models/link.model';
import { EditLink } from 'src/app/reports/shared/link/models/edit-link.model';
import { SelectedShape } from 'src/app/reports/shared/link/models/selected-shape.model';
import { LinkGroup } from 'src/app/reports/shared/link/models/link-group.model';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BeforeSelectElementOnEditLink } from 'src/app/reports/shared/link/models/before-select-element-on-edit-link.model';
import { RelationZoomComponent } from './relation-zoom/relation-zoom.component';
import { RelationOptionsComponent } from './relation-options/relation-options.component';
import { DropItemService } from './drop-item/drop-item.service';
import { LinkGroupConfig } from 'src/app/reports/shared/link/models/link-group-config.model';
import { Report } from '../../../models/report.model';
import { RteDialog } from 'rte-library';
import { findElementByTagName } from 'src/app/reports/helpers/element.helper';
import { getCoordinateFromMouseEvent } from 'src/app/reports/shared/link/helpers/element-position.helper';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';
import { JoinTypeEnum } from 'src/app/reports/enums/join-type.enum';
import { setElementPositionByCoordinates } from 'src/app/reports/helpers/element-style.helper';

@Component({
  animations: [
    trigger('option-visibility', [
      state('hidden', style({
        display: 'none',
        top: '30px',
        opacity: 0
      })),
      state('visible', style({
        opacity: 1
      })),
      transition('* <=> *', animate('300ms 0s ease'))
    ])
  ],
  selector: 'app-relation',
  templateUrl: './relation.component.html',
  styleUrls: ['./relation.component.scss']
})
export class RelationComponent extends BaseComponent implements OnInit, OnDestroy, DoCheck {

  //#region Inputs

  @Input() disabled = false;
  @Input() cdkDragDisabled = false;

  @Input() report: Report;
  @Input() entities: Array<ReportEntity> = new Array<ReportEntity>();
  @Input() relatedEntities: Array<RelatedEntity> = new Array<RelatedEntity>();

  @Input() columnDragulaGroup: string;
  @Input() linkGroupName: string;

  @Input() sessionId: string;

  //#endregion

  //#region Outputs

  @Output() onDeleteEntity = new EventEmitter<ReportEntity>();
  @Output() entitiesChange = new EventEmitter<Array<ReportEntity>>();
  @Output() relatedEntitiesChange = new EventEmitter<Array<RelatedEntity>>();

  //#endregion

  //#region Properties

  differEntities: IterableDiffer<any>;
  contents: Array<any> = new Array<any>();
  group: LinkGroup;
  optionAnimationState = 'hidden';
  selectedLink: Link;
  componentLoaded = false;

  @ViewChild('content', {read: ElementRef}) contentRef: ElementRef;
  @ViewChild('options', {read: RelationOptionsComponent}) optionsRef: RelationOptionsComponent;
  @ViewChild('zoom', {read: RelationZoomComponent}) zoomRef: RelationZoomComponent;

  //#endregion

  //#region Ctor

  constructor(
    private linkService: LinkService,
    private dialog: RteDialog,
    private differs: IterableDiffers,
    private renderer: Renderer2,
    private queryService: QueryService,
    private dropItemService: DropItemService
    ) {
      super();
  }

  //#endregion

  //#region Interface implementations

  ngOnInit() {
    this.configureLinkGroup();
    this.linkRegistredElement();

    this.differEntities = this.differs.find(this.entities).create(null);
  }

  ngOnDestroy() {
    this.linkService.removeGroup(this.linkGroupName);
    this.subscription.unsubscribe();
  }

  ngDoCheck() {

    this.componentLoaded = true;

    if (this.differEntities.diff(this.entities)) {
      setTimeout(() => {
        this.entitiesChange.emit(this.entities);
      }, 0);
    }

    this.linkService.setDisabledToGroup(this.linkGroupName, this.disabled);
  }

  //#region Configuration

  configureLinkGroup() {
    const config: LinkGroupConfig = {
      lineWidth: 4.5,
      placeHolderColor: 'rgb(138,138,138)',
      primaryColor: 'rgba(85, 85, 85, 0.92)',
      radius: 7,
      tension: 0.8
    };

    this.linkService.setGroup(this.linkGroupName, config, this.report.Scale);
    this.group = this.linkService.getGroupByName(this.linkGroupName);
  }

  //#endregion

  //#region Link Elements Methods

  linkRegistredElement() {

    if (this.relatedEntities != null && this.relatedEntities.length > 0) {

      const relateds = this.relatedEntities.concat(),
        loaded = [];

      this.subscription.add(
        this.queryService.afterStoreColumnHeaders.subscribe(() => {

          const notLoaded = relateds.filter(x => !loaded.includes(x));

          notLoaded.forEach(value => {

            const firstColumnsHeaders = this.queryService.getEntityColumnHeader(value.EntityId),
            secondColumnsHeaders = this.queryService.getEntityColumnHeader(value.RelatedEntityId);

            if (firstColumnsHeaders && secondColumnsHeaders) {
              const firstColumns = this.queryService.converColumnHeadersToColumns(firstColumnsHeaders.Columns, this.getReportEntitybyId(value.ReportEntityId)),
              secondColumns = this.queryService.converColumnHeadersToColumns(secondColumnsHeaders.Columns, this.getReportEntitybyId(value.RelatedReportEntityId));

              if (firstColumns && secondColumns) {
                const first = this.findColumn(value.ColumnName, firstColumns),
                second = this.findColumn(value.RelatedColumnName, secondColumns);

                if (first && second) {

                  loaded.push(value);

                  setTimeout(() => {
                    this.linkService.registerVirtualLinkByData(first, second, this.linkGroupName);

                    if (loaded.length === relateds.length) {
                      this.linkElementEvents();
                    }
                  });
                }
              }
            }
          });
        })
      );
    } else {
      this.linkElementEvents();
    }
  }

  linkElementEvents() {
    setTimeout(() => {
      this.afterRegisterTargetEvent();
      this.beforeRemoveTargetEvent();
      this.onLinkSelectedEvent();
      this.beforeLinkElementsEvent();
      this.afterRegisterElementsEvent();
      this.onEditLinkEvent();
      this.beforeSelectElementOnEditLinkEvent();
    });
  }

  onLinkSelectedEvent() {
    this.subscription.add(
      this.linkService.onLinkSelected.subscribe( (seleted: SelectedShape) => {
        let link = null,
          event = null;

        if (seleted) {
          event = seleted.event;
          link = seleted.link;
        }

        this.selectedLink = link;
        this.adjustOptionsCoordinates(event);
      })
    );
  }

  adjustOptionsCoordinates(event: MouseEvent) {
    if (event) {
      this.adjustElementCoordinates(event, this.optionsRef.elm.nativeElement);
    }
  }

  adjustElementCoordinates(event: MouseEvent, elm: any) {
    const coordinates = getCoordinateFromMouseEvent(event, this.group.contentRef, this.group.scale);

    if (this.optionsRef != null && coordinates) {
      const scale = this.report.Scale;
      coordinates.x = coordinates.x - (scale > 1 ? (10 * scale) : (10 / scale));
      coordinates.y = coordinates.y - (scale > 1 ? (40 * scale) : (40 / scale));

      setElementPositionByCoordinates(coordinates, elm, this.renderer);
    }
  }

  afterRegisterTargetEvent() {
    this.subscription.add(
      this.linkService.afterRegisterTarget.subscribe((link: LinkElement) => {
        this.alterStyleOfColumnSelected(link.element, true);
        this.cancelSelectedRelation();
      })
    );
  }

  beforeRemoveTargetEvent() {
    this.subscription.add(
      this.linkService.beforeRemoveTarget.subscribe( (link: LinkElement) => {
        this.alterStyleOfColumnSelected(link.element, false);
        this.cancelSelectedRelation();
      })
    );
  }

  alterStyleOfColumnSelected(element, active) {
    if (active) {
      this.renderer.setStyle(element, 'background-color', 'rgba(107, 107, 107, 0.14)');
      this.renderer.setStyle(element, 'box-shadow', '2px 2px 7px 1px rgba(0, 0, 0, 0.55)');
    } else {
      this.renderer.removeStyle(element, 'background-color');
      this.renderer.removeStyle(element, 'box-shadow');
    }
  }

  beforeLinkElementsEvent() {
    this.subscription.add(
      this.linkService.beforeRegisterLink.subscribe( (register: BeforeRegisterLink) => {
        if (register.oldElement != null) {
          register.removeFisrtTarget = this.isElementOnSameParent(register.oldElement, register.newElement);
        }
      })
    );
  }

  afterRegisterElementsEvent() {
    this.subscription.add(
      this.linkService.afterRegisterLink.subscribe((afterLink: AfterRegisterLink) => {
        this.verifyRelatedEntities(afterLink.links);
      })
    );
  }

  onEditLinkEvent() {
    this.subscription.add(
      this.linkService.onEditLink.subscribe((onEdit: EditLink) => {
        this.verifyRelatedEntities(onEdit.data);
        this.alterStyleOfColumnSelected(onEdit.newElement.element, false);
      })
    );
  }

  beforeSelectElementOnEditLinkEvent() {
    this.subscription.add(
      this.linkService.beforeSelectElementOnEditLink.subscribe((before: BeforeSelectElementOnEditLink) => {
        this.cancelSelectedRelation();

        let otherElement = null;

        if (before.oldElement) {
          this.alterStyleOfColumnSelected(before.oldElement.element, false);
        }

        if (before.newElement) {
          otherElement = before.link.first == before.originalElement ? before.link.second : before.link.first;

          before.cancel = this.isElementOnSameParent(otherElement.element, before.newElement.element);

          if (!before.cancel) {
            this.alterStyleOfColumnSelected(before.newElement.element, true);
          }
        }
      })
    );
  }

  isElementOnSameParent(oldElm: Element, newElm: Element) {
    const oldParent = findElementByTagName(oldElm, 'app-entity-detail'),
      newParent = findElementByTagName(newElm, 'app-entity-detail');

    return oldParent == newParent;
  }

  verifyRelatedEntities(links: Array<Link>) {
    if (links == null) {
      return;
    }

    const aux = [];

    links.forEach(value => {

      const find = this.getRelatedEntitiesByLink(value);

      if (find != null) {
        aux.push(find);
      } else {
        const first: Column = value.first.data,
            firstEntity = this.getReportEntitybyId(first.ReportEntityId),
            second: Column = value.second.data,
            secondEntity = this.getReportEntitybyId(second.ReportEntityId);

        if (first && second) {
          aux.push({
            ReportEntityId: first.ReportEntityId,
            EntityId: first.EntityId,
            ColumnName: first.Name,
            EntityAlias: firstEntity != null ? (firstEntity.Alias ? firstEntity.Alias : firstEntity.Entity.Description) : '',
            RelatedReportEntityId: second.ReportEntityId,
            RelatedColumnName: second.Name,
            RelatedEntityAlias: secondEntity != null ? (secondEntity.Alias ? secondEntity.Alias : secondEntity.Entity.Description) : '',
            RelatedEntityId: second.EntityId,
            JoinType: JoinTypeEnum.Inner
          });
        }
      }
    });

    this.relatedEntities = aux;

    this.relatedEntitiesChange.emit(this.relatedEntities);
  }

  cancelSelectedRelation() {
    if (this.selectedLink != null) {
      this.selectedLink = null;
    }
  }

  getRelatedEntitiesByLink(link: Link): RelatedEntity {
    let find: RelatedEntity = null;

    if (link && link.first && link.second) {
      const first = link.first.data,
        second = link.second.data;

      find =
      this.relatedEntities.find(x => {
        return x.ReportEntityId === first.ReportEntityId &&
        x.EntityId === first.EntityId &&
        x.ColumnName === first.Name &&
        x.RelatedReportEntityId ===  second.ReportEntityId &&
        x.RelatedColumnName ===  second.Name &&
        x.RelatedEntityId ===  second.EntityId;
      });
    }

    return find;
  }

  //#endregion

  //#endregion

  //#region Events

  onContentScroll(event) {
    const element = this.contentRef.nativeElement,
      zoomElement = this.zoomRef.elm.nativeElement,
      right = (element.scrollLeft * -1) + 10,
      top = (element.scrollTop);

    this.renderer.setStyle(zoomElement, 'right', right.toString() + 'px');
    this.renderer.setStyle(zoomElement, 'top', top.toString() + 'px');
  }

  onDeleteClick(entity: ReportEntity) {
    this.validBeforeDeleteEntity(entity);
  }

  onMainClick(entity: ReportEntity) {
    if (!entity.IsMain) {
      entity.IsMain = true;

      const filter = this.entities.filter(x => x.Id !== entity.Id);

      if (filter != null && filter.length > 0) {
        filter.forEach(item => item.IsMain = false);
      }
    }
  }

  onMove(entity: ReportEntity) {

    this.cancelSelectedRelation();

    this.updateCoordenates(entity);
  }

  onDeleteRelation(link: Link) {
    const group = this.linkService.getGroupByName(this.linkGroupName);
    this.linkService.removeLink(link, group);
    this.cancelSelectedRelation();

    const links = this.linkService.getLinksByGroup(this.linkGroupName);
    this.verifyRelatedEntities(links);
  }

  onStopMove() {
    setTimeout(() => {
      this.updateCoordenates();
    }, 100);
  }

  onScaleChange(scale) {
    this.linkService.updateScaleNumberOfGroup(scale, this.linkGroupName);
    this.updateCoordenates();
    this.cancelSelectedRelation();
    this.dropItemService.updateCoordinates.emit();
  }

  updateCoordenates(entity = null) {

    if (entity != null) {
      const obj = this.getReportEntitybyId(entity.Id);
      if (obj) {
        obj.Configuration = entity.Configuration;
      }
    }

    this.linkService.updateCoordenates(this.linkGroupName);
  }

  //#endregion

  //#region Delete Entity

  validBeforeDeleteEntity(entity: ReportEntity) {
    let msg = '',
        description = '',
        columnLength = entity.Columns.length,
        filterLength = entity.Filters.length;
    if (columnLength > 0) {
      msg += `Há ${columnLength} coluna(s) `;
    }

    if (filterLength > 0) {
      if (msg) {
        msg += `e ${filterLength} filtro(s) `;
      }
      else {
        msg = `Há ${filterLength} filtro(s) `;
      }
    }

    if (msg) {
      description = msg + `vinculado(s) para a entidade ${entity.Alias}. Deseja continuar com a operação?`;

      DialogConfirmHelper.showConfirmDialog(this.dialog, description).subscribe(value => {
        if (value) {
          this.removeEntity(entity);
        }
      });
    } else {
      this.removeEntity(entity);
    }
  }

  removeEntity(entity: ReportEntity) {
    const index = this.entities.indexOf(entity);
    if (index !== -1) {
      this.entities.splice(index, 1);

      this.removeReletedEntityByReportEntity(entity);

      this.onDeleteEntity.emit(entity);

      setTimeout(() => {
        this.linkService.checkElements(this.linkGroupName);
        this.cancelSelectedRelation();
      }, 0);
    }
  }

  removeReletedEntityByReportEntity(entity: ReportEntity) {
    const links = this.linkService.getLinksByGroup(this.linkGroupName);

    let search = links.filter(x => x.first.data.ReportEntityId === entity.Id || x.second.data.ReportEntityId === entity.Id);

    if (search != null && search.length > 0) {
      search = search.concat();

      search.forEach(element => {
        this.onDeleteRelation(element);
      });
    }
  }

  //#endregion

  //#region Utils

  getReportEntitybyId(id: number): ReportEntity {
    return this.entities.find(value => {
      return value.Id == id;
    });
  }

  findColumn(name: string, columns: Array<Column>): Column {
    let column = null;
    if (columns && columns.length > 0) {
      column = columns.find(value => {
        return value.Name === name;
      });
    }

    return column;
  }

  //#endregion

  //#region Animations

  optionVisibisity(): string {
    return this.selectedLink != null ? 'visible' : 'hidden';
  }

  //#endregion
}
